import { BaseContext } from '../../../../utils/basecontext';
import { APIModel, APIModelHandler, APIModelImpl } from '../../../toolkit/uicomponentapimodel';
import { FlashMessageProcessorFactory } from 'src/com/sixdee/crbtportal/core/processorfactory/flashmessageprocessorfactory';
import { GetPredefinedFlashMessageRequestImpl } from 'src/com/sixdee/crbtportal/core/api/flashmessage/getpredefinedflashmessages/getpredefinedflashmessagesrequest';
import { GetPredefinedFlashMessageResponse } from 'src/com/sixdee/crbtportal/core/api/flashmessage/getpredefinedflashmessages/getpredefinedflashmessagesresponse';

export interface FlashMessageAPIModel extends APIModel
{
    getFlashMessage(): void;
}

export class FlashMessageAPIModelImpl extends APIModelImpl implements FlashMessageAPIModel
{
    private flashMessageProcessorFactory: FlashMessageProcessorFactory;
   
    constructor(applicationContext: BaseContext, apiModelHandler: APIModelHandler)
    {
        super(applicationContext, apiModelHandler);

        this.flashMessageProcessorFactory = this.getAPIProcesssorFactory().getFlashMessageProcessorFactory();
    }

    getFlashMessage(): void 
    {
        this.flashMessageProcessorFactory.getPredefinedFlashMessageAPIProcessor()
        .success((getFlashMessageResponse: GetPredefinedFlashMessageResponse)=>
                  {
                     this.getAPIModelHandler().onSuccess(getFlashMessageResponse.getAPIFeature(), 
                     getFlashMessageResponse.getDescription(), getFlashMessageResponse.getFlashMessageResponseDtos()); 
                  })
                  .failure((getFlashMessageResponse : GetPredefinedFlashMessageResponse)=>
                  {
                      this.getAPIModelHandler().onFailure(getFlashMessageResponse.getAPIFeature(), 
                      getFlashMessageResponse.getDescription(), undefined);
                    
                  })
                  .execute(new GetPredefinedFlashMessageRequestImpl());

    }

    getLoadMoreFlashMessages(categoryId: number, title: string, startIndex: number, offset: number): void 
    {
    }

    // let featuredCategoryDto = new FeaturedCategoryDtoImpl();
    // featuredCategoryDto.setIdentifier(this.getContext().getResources().getString(Strings.default_flash_message));
    // featuredCategoryDto.setTitle(this.getContext().getResources().getString(Strings.default_flash_message));
    // featuredCategoryDto.setMsisdn(this.getContext().getUserContext().getMsisdn() === "" ? "0" : this.getContext().getUserContext().getMsisdn());
    // featuredCategoryDto.setLanguage(this.getContext().getUserContext().getLanguage());

    // let listOftones = [];
    // let toneDto1 = new ToneDtoImpl();
    // toneDto1.setId("1");
    // toneDto1.setToneName("23");
    // toneDto1.setArtistName("jhg");
    // listOftones.push(toneDto1);

    // featuredCategoryDto.setListOfTones(listOftones);

    // this.getAPIModelHandler().onSuccess(APIFeatures.FLASH_MESSAGE, 
    //              "", featuredCategoryDto); 
}


 


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/flashmessage/flashmessageapimodel.tsx